import React, { Component } from 'react';
import { Container, Col, Row } from 'reactstrap';
import { T } from '../traks';
import { A } from '../routes';
import { site_name } from '../Site';
import OurLogo from '../c/OurLogo';
import OurAdSense from '../c/OurAdSense.js';
import { ordered_and_available_market_ids } from '../markets.js';
import { using_cookiebot } from '../c/Cookiebot.js';

class Footer extends Component {
	render() {
		const our_logo = <OurLogo/>;

		let ad_sense_stuff = null;
		let insta_link, fb_link, linkedin_link;
		let footer_imprint_title  = <T>Contact us</T>;

		if (IS_AKTIEDYSTEN_DK) {
			insta_link = "https://www.instagram.com/aktiedysten";
			fb_link = "https://www.facebook.com/aktiedysten";
			linkedin_link = "https://www.linkedin.com/company/12662458";
		} else if (IS_AKTIEKAMPEN_SE) {
			insta_link = "https://www.instagram.com/aktiekampen_se";
			fb_link = "https://www.facebook.com/aktiekampen";
		} else if (IS_INVESTSPIEL_DE) {
			insta_link = "https://www.instagram.com/investspiel_de";
			fb_link = "https://www.facebook.com/investspiel";
			footer_imprint_title = <T>Imprint / Contact</T>;
		} else if (IS_TRADERR_COM) {
			insta_link = "https://www.instagram.com/traderr_investing/";
			fb_link = "https://www.facebook.com/TraderrFantasyInvesting";
		}

		if (IS_INVESTSPIEL_DE) {
			ad_sense_stuff = (
				<Container>
					<Row className="pb-4">
						<Col xs="12">
							<div className="text-center">
								<OurAdSense dataAdSlot="5609577450" />
							</div>
						</Col>
					</Row>
				</Container>
			);
		}

		const ImgUrlsSOME = (props) => (
			<React.Fragment>
				<div className="pt-4 ad_pr_11px">
					<a alt="Facebook" href={fb_link} rel="noopener noreferrer" target="_blank"><img alt="" src="https://static.aktiedysten.dk/gfx/logo-facebook-footer-2023-0.svg" /></a>
				</div>
				{insta_link && (
					<div className="ad_pr_11px pt-4">
						<a alt="Instagram" href={insta_link} rel="noopener noreferrer" target="_blank"><img alt="" src="https://static.aktiedysten.dk/gfx/logo-instagram-footer-2023-0.svg" /></a>
					</div>
				)}
				{linkedin_link && (
					<div className="ad_pr_11px pt-4">
						<a alt="LinkedIn" href={linkedin_link} rel="noopener noreferrer" target="_blank"><img alt="" src="https://static.aktiedysten.dk/gfx/logo-linkedin-footer-2023-0.svg" /></a>
					</div>
				)}
			</React.Fragment>
		);

		const explore_market_map = {
			"DK_STOCK": (
				<div className="font-small pt-2 pt-md-4">
					<A className="ad_footer_link" href="/explore-cph"><T>Danish Market</T></A>
				</div>
			),
			"SE_STOCK": (
				<div className="font-small pt-3">
					<A className="ad_footer_link" href="/explore-sto"><T>Swedish Market</T></A>
				</div>
			),
			"DE_STOCK": (
				<div className="font-small pt-3">
					<A className="ad_footer_link" href="/explore-xetra"><T>German Market</T></A>
				</div>
			),
			"FI_STOCK": (
				<div className="font-small pt-3">
					<A className="ad_footer_link" href="/explore-hel"><T>Finnish Market</T></A>
				</div>
			),
			"AT_STOCK": (
				<div className="font-small pt-3">
					<A className="ad_footer_link" href="/explore-vie"><T>Austrian Market</T></A>
				</div>
			),
			"IS_STOCK": (
				<div className="font-small pt-3">
					<A className="ad_footer_link" href="/explore-ice"><T>Icelandic Market</T></A>
				</div>
			),
			"US_STOCK": (
				<div className="font-small pt-3">
					<A className="ad_footer_link" href="/explore-us"><T>American Market</T></A>
				</div>
			),
			"COMMODITIES": (
				<div className="font-small pt-3">
					<A className="ad_footer_link" href="/explore-commodities"><T>Commodity Market</T></A>
				</div>
			),
			"FOREX": (
				<div className="font-small pt-3">
					<A className="ad_footer_link" href="/explore-bank"><T>Currency Market</T></A>
				</div>
			),
			"CRYPTOCURRENCIES": (
				<div className="font-small pt-3">
					<A className="ad_footer_link" href="/explore-crypto"><T>Crypto Market</T></A>
				</div>
			)
		};

		const explore_markets = ordered_and_available_market_ids.map(id => <React.Fragment key={id}>{explore_market_map[id]}</React.Fragment>);

		return (
			<React.Fragment>
			{ad_sense_stuff}
			<Container fluid className="navbar-dark"><Container>
				<Row>
					<Col>
						<Row className="pt-3">
							<Col xs="12" md="2" className="text-right">
								<div className="ad_pt_2px">
									{our_logo}
								</div>
							<div className="d-none d-md-flex flex-row-reverse">
								<ImgUrlsSOME />
							</div>
							<div className="d-flex d-md-none pb-3">
								<ImgUrlsSOME />
							</div>
							</Col>
							<Col xs="12" md="3" className="pl-md-5 pb-4">
								<div className="font-small ad_footer_header pt-2 pl-md-4">
									{site_name}
								</div>
								<div className="font-small pt-2 pt-md-4 pl-md-4">
									<A className="ad_footer_link" href="/equity-abc"><T>Investment ABC</T></A>
								</div>
								{IS_AKTIEDYSTEN_DK &&
								<React.Fragment>
									<div className="font-small pt-3 pl-md-4">
										<a className="ad_footer_link" href="https://inspiration.aktiedysten.dk">Inspiration</a>
									</div>
									<div className="font-small pt-3 pl-md-4">
										<A className="ad_footer_link" href="/faq">FAQ</A>
									</div>
								</React.Fragment>
									}
								<div className="font-small pt-3 pl-md-4">
									<A className="ad_footer_link" href="/about"><T>About Aktiedysten</T></A>
								</div>
								<div className="font-small pt-3 pl-md-4">
									<A className="ad_footer_link" href="/privacy"><T>Privacy policy</T></A>
								</div>
								{ using_cookiebot() && (
									<div className="font-small pt-3 pl-md-4">
										<A className="ad_footer_link" href="/cookies"><T>About cookies</T></A>
									</div>
								) }
								<div className="font-small pt-3 pl-md-4">
									<A className="ad_footer_link" href="/termsofuse"><T>Terms of use</T></A>
								</div>
								<div className="font-small pt-3 pl-md-4">
									<A className="ad_footer_link" href="/contact">{footer_imprint_title}</A>
								</div>
							</Col>
							<Col xs="12" md="3" className="pl-md-4 pb-4">
								<div className="font-small ad_footer_header pt-2">
									<A className="ad_footer_header" href="/explore"><T>Explore</T></A>
								</div>
								{explore_markets}
							</Col>
							{IS_AKTIEDYSTEN_DK &&
							<Col xs="12" md="3" className="pl-md-4 pb-4">
								<div className="font-small ad_footer_header pt-2">
									<T>More with {site_name}</T>
								</div>
								<div className="font-small pt-3">
									<a className="ad_footer_link" target="_blank" rel="noopener noreferrer" href="https://undervisning.aktiedysten.dk/"><T>Learn with {site_name}</T></a>
								</div>
								<div className="font-small pt-3">
									<a className="ad_footer_link" target="_blank" rel="noopener noreferrer" href="https://sammen.aktiedysten.dk/"><T>Create your own game</T></a>
								</div>
								<div className="font-small pt-3">
									<a className="ad_footer_link" target="_blank" rel="noopener noreferrer" href="https://sammen.aktiedysten.dk/bliv-partner/"><T>Cooperate with {site_name}</T></a>
								</div>
							</Col>}
						</Row>
					</Col>
				</Row>
			</Container></Container>
			</React.Fragment>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/c/Footer.js